
import React, { lazy, Suspense, useMemo, useState, useEffect, useContext } from "react";
import { useLocation, useHistory } from "react-router-dom";
import Routes from "../../routes";
import { getCookie, setCookie } from "../../utils/utils";
import { StoreContext } from "../ContextStore/StoreContextProvider";
import { useUxVersion } from "../ContextStore/UxVersionContext";
import MicroserviceFetchUtil from "../../common/microservice-fetch-util";
import BrandingLoader from "../Brandingloader/BrandingLoader";
import { DropdownProvider as DropdownProviderV2 } from "../../components_upgrade/Header/HeaderTimeDetails/DropdownContext";
import HeaderV2 from "../../components_upgrade/Header/Header";
import LandingHeaderV2 from "../../components_upgrade/LandingHomePage/LandingHeader/LandingHeader";
import PageBackgroundV2 from "../../components_upgrade/PageBackground/PageBackground";
import {
  ROUTES_WITHOUT_HEADER,
  UCUBE_ROUTES,
  OPERATIONAL_REPORT_ROUTES,
  ADMIN_ROUTES
} from "../../constants/routeConfig";
// V1 components - lazy loaded
const HeaderV1 = lazy(() => import("../Header/Header"));
const LandingHeaderV1 = lazy(() => import("../LandingHomePage/LandingHeader/LandingHeader"));

const Main = () => {
  const { isUpgraded } = useUxVersion();
  const {
    userDetails,
    updateUserDetails,
    selectedCountryCode,
    updateCountryCode,
  } = useContext(StoreContext);
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(Boolean(getCookie("idToken")));
  const { pathname } = useLocation();

  const { hasHeader } = useMemo(() => {
    return {
      hasHeader: !ROUTES_WITHOUT_HEADER.some(route =>
        route instanceof RegExp
          ? route.test(pathname)
          : pathname.search(route) !== -1
      ),
    };
  }, [pathname]);
  const { hasUcubeHeader, hasOperationalReportsHeader, hasAdminHeader } = useMemo(() => {
    return {
      hasUcubeHeader: UCUBE_ROUTES.includes(pathname),
      hasOperationalReportsHeader: OPERATIONAL_REPORT_ROUTES.includes(pathname),
      hasAdminHeader: ADMIN_ROUTES.includes(pathname),
    };
  }, [pathname]);

  useEffect(() => {
    const idToken = getCookie("idToken");
    if (idToken === null && pathname !== "/signup") {
      console.log("userDetailsPath..", pathname, idToken);
      history.push("/login");
      return;
    }
    if (idToken !== null) {
      console.log("userDetailsToken..", pathname, localStorage.getItem("email"), localStorage.getItem("countryCode"), idToken);
      setIsLoading(true);
      const userEmailObj = { email: localStorage.getItem("email") };
      MicroserviceFetchUtil.post(
        "fb/users/profile",
        {
          customerToken: idToken,
          countryCode: localStorage.getItem("countryCode"),
        },
        userEmailObj
      )
        .then(response => {
          console.log("userDetailsResponse..", response);
          if (response.statusCode === 200 && response["response-data"]) {
            updateUserDetails(response["response-data"]);
            updateCountryCode(localStorage.getItem("countryCode"));
            setCookie("countryCode", localStorage.getItem("countryCode"));
          } else {
            console.error("Unexpected response while fetching user profile:", response);
          }
        })
        .catch(error => {
          console.error("Error while fetching user profile:", error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
    console.log("userDetails..", userDetails);
  }, [selectedCountryCode]);

  console.log("hits", history, pathname);
  const mainContent = (
    <div
      key={`main-${isUpgraded}`}
      data-ux-version={isUpgraded ? "v2" : "v1"}
      data-route-type={hasOperationalReportsHeader ? "operational" : hasAdminHeader ? "admin" : hasUcubeHeader ? "ucube" : "other"}
      className={`mainContainer ${isUpgraded && !hasOperationalReportsHeader && !hasAdminHeader ? "transparentBg" : ""}`}>
      {isUpgraded && (
        <Suspense fallback={<></>}>
          <PageBackgroundV2 />
        </Suspense>
      )}
      <Suspense fallback={<></>} key={`header-suspense-${isUpgraded}`}>
        {hasHeader && isUpgraded && hasUcubeHeader && <HeaderV2 />}
        {hasHeader && isUpgraded && hasOperationalReportsHeader && <LandingHeaderV2 />}
        {hasHeader && isUpgraded && hasAdminHeader && <LandingHeaderV2 />}
        {hasHeader && isUpgraded && !hasUcubeHeader && !hasOperationalReportsHeader && !hasAdminHeader && <LandingHeaderV2 />}
        {hasHeader && !isUpgraded && hasUcubeHeader && <HeaderV1 />}
        {hasHeader && !isUpgraded && hasOperationalReportsHeader && <LandingHeaderV1 />}
        {hasHeader && !isUpgraded && hasAdminHeader && <LandingHeaderV1 />}
        {hasHeader && !isUpgraded && !hasUcubeHeader && !hasOperationalReportsHeader && !hasAdminHeader && <LandingHeaderV1 />}
      </Suspense>
      <Routes key={`routes-${isUpgraded}`} />
    </div>
  );
  if (isLoading) {
    return <BrandingLoader />;
  }
  return isUpgraded ? (
    <DropdownProviderV2 key={`v2-wrapper-${isUpgraded}`}>
      {mainContent}
    </DropdownProviderV2>
  ) : (
    mainContent
  );
};
export default Main;
